import { createSlice } from '@reduxjs/toolkit';
import { VIEW_MODES } from '../../pages/vehicleModel/components/CompatibilityTable/CompatibilityTable';

const initialState = {
  pageNumber:1,
  searchFilter: null,
  viewMode: VIEW_MODES.LIST,
  genericSearchEnabled: true,
  category: null
};

export const vehicleModelFilterSlice = createSlice({
  name: 'vehicleModelFilter',
  initialState,
  reducers: {
    setPageNumber(state, { payload }) {
      state.pageNumber = payload;
    },
    resetPageNumber(state) {
      state.pageNumber = 1;
    },
    setSearchFilters(state, { payload }) {
      state.searchFilter = payload;
    },
    resetSearchFilters(state) {
      state.searchFilter = null;
    },
    setViewMode(state, { payload }) {
      state.viewMode = payload;
    },
    setGenericSearchEnabled(state, { payload }) {
      state.genericSearchEnabled = payload;
    },
    setCategory(state, { payload }) {
      state.category = payload;
    }
  }
});

// Actions
export const { 
  setSearchFilters, 
  resetSearchFilters, 
  resetPageNumber, 
  setPageNumber,
  setViewMode,
  setCategory,
  setGenericSearchEnabled
} = vehicleModelFilterSlice.actions;

export default vehicleModelFilterSlice.reducer;
